
import {Component, Prop, Vue} from "vue-property-decorator";
import {routeMaps} from "@/functions/routeMap";
import {withUtm} from "@/functions/formedgeLink";

@Component
export default class TemplateFooter extends Vue {
  @Prop({type: Boolean, required: false, default: true})
  showLink: boolean;

  private routeMaps = routeMaps;

  // 外部リンクには流入元計測用の UTM を付与（全ページ共通のフッターなので campaign は "common"）
  private externalLink(url: string): string {
    return withUtm(url, "common", "footer");
  }

  // data
  year = this.#getThisYear();

  // method
  #getThisYear(): number {
    return new Date().getFullYear();
  }
}
